import { postData } from 'helpers/RequestHelper';

const startVerify = (channel = 'sms') => {
  return postData({
    url: '/auth/login/mfa/start_verify',
    body: { channel },
    catchErrors: false
  })
    .then((response) => response)
    .catch((error) => window.Raven.captureException(error));
};

const validateCode = (code) => {
  return postData({
    url: '/auth/login/mfa/validate_code',
    body: { code },
    catchErrors: false
  })
    .then((response) => response)
    .catch((error) => window.Raven.captureException(error));
};

export { startVerify, validateCode };
